import { type VariationComponent, getAudio } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    const messages = checkItemArrayIntegrity(items);

    const [story] = items?.filter((item) => getAudio(item)?.url) || [];

    if (!story) {
        messages.push("This module has no story with compatible audio.");
    }

    return messages;
}
